// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bookmark-body {
    padding: 0.5em;
    height: 100%;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
}

.bookmark-body > h4 {
    flex: 0 0 auto;
}

div.bookmark-create {
    display: flex;
    flex: 0 0 auto;
}

div.bookmark-create > input {
    flex: 1 1 auto;
    border-radius: 0;
}

div.bookmark-actions {
    display: flex;
    margin: 0.5em 0;
}

span.bookmark-actions-buttonbox {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
}

span.bookmark-actions-spacer {
    flex: 1 1 auto;
}


span.bookmark-actions-buttonbox > button:not(:last-child) {
    margin-right: -1px;
}

span.bookmark-actions-buttonbox > button:not(:disabled) > span.icon-trash {
    color: red;
}

div.bookmark-list {
    border: 1px solid var(--border-color);
    background-color: var(--list-bg-color);
}

div.bookmark-list-item {
    padding: 0.5em;
    overflow: hidden;
    overflow-wrap: anywhere;
}

div.bookmark-list-item-empty {
    padding: 0.5em;
    font-style: italic;
    color: var(--text-color-disabled);
}

div.bookmark-list-item:not(.bookmark-list-item-active):nth-child(even) {
    background-color: var(--list-item-bg-color-even);
}

div.bookmark-list-item:hover {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}

div.bookmark-list-item-active {
    background-color: var(--list-item-bg-color-active);
    color: var(--list-item-text-color-active);
}

div.bookmark-list-item-active:hover {
    background-color: var(--list-item-bg-color-active-hover);
    color: var(--list-item-text-color-active-hover);
}
`, "",{"version":3,"sources":["webpack://./qwc2/plugins/style/Bookmark.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,wDAAwD;IACxD,+CAA+C;AACnD","sourcesContent":[".bookmark-body {\n    padding: 0.5em;\n    height: 100%;\n    overflow-y: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.bookmark-body > h4 {\n    flex: 0 0 auto;\n}\n\ndiv.bookmark-create {\n    display: flex;\n    flex: 0 0 auto;\n}\n\ndiv.bookmark-create > input {\n    flex: 1 1 auto;\n    border-radius: 0;\n}\n\ndiv.bookmark-actions {\n    display: flex;\n    margin: 0.5em 0;\n}\n\nspan.bookmark-actions-buttonbox {\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n}\n\nspan.bookmark-actions-spacer {\n    flex: 1 1 auto;\n}\n\n\nspan.bookmark-actions-buttonbox > button:not(:last-child) {\n    margin-right: -1px;\n}\n\nspan.bookmark-actions-buttonbox > button:not(:disabled) > span.icon-trash {\n    color: red;\n}\n\ndiv.bookmark-list {\n    border: 1px solid var(--border-color);\n    background-color: var(--list-bg-color);\n}\n\ndiv.bookmark-list-item {\n    padding: 0.5em;\n    overflow: hidden;\n    overflow-wrap: anywhere;\n}\n\ndiv.bookmark-list-item-empty {\n    padding: 0.5em;\n    font-style: italic;\n    color: var(--text-color-disabled);\n}\n\ndiv.bookmark-list-item:not(.bookmark-list-item-active):nth-child(even) {\n    background-color: var(--list-item-bg-color-even);\n}\n\ndiv.bookmark-list-item:hover {\n    background-color: var(--list-item-bg-color-hover);\n    color: var(--list-item-text-color-hover);\n}\n\ndiv.bookmark-list-item-active {\n    background-color: var(--list-item-bg-color-active);\n    color: var(--list-item-text-color-active);\n}\n\ndiv.bookmark-list-item-active:hover {\n    background-color: var(--list-item-bg-color-active-hover);\n    color: var(--list-item-text-color-active-hover);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
